import { create } from 'zustand';

type ThemeStore = {
  isDarkMode: boolean;
  isCollapsed: boolean;
  toggleDarkMode: () => void;
  toggleCollapsed: () => void;
};

export const useThemeStore = create<ThemeStore>()((set) => ({
  isDarkMode: false,
  isCollapsed: false,
  toggleDarkMode: () =>
    set((state) => {
      const newDarkMode = !state.isDarkMode;
      if (newDarkMode) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
      return { isDarkMode: newDarkMode };
    }),
  toggleCollapsed: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
}));
